/**
 * Feature flag names used throughout the application.
 * These correspond to keys in config.featuresFlags (from REACT_APP_FEATURES_FLAGS env variable).
 *
 * Usage:
 *   import { FeatureFlags } from 'config/featureFlags';
 *   config.featuresFlags[FeatureFlags.DISCLAIMER]
 */
export const FeatureFlags = {
    ACCOUNT_TYPE: 'accountType',
    AUTO_KYC_SUMSUB: 'autoKycSumSub',
    BLOCK_NEW_REGISTRATION: 'blockNewRegistration',
    CCS_ONLY: 'ccsOnly',
    CZ_FEATURES: 'czFeatures',
    CZ_REGULATION: 'czRegulation',
    DEMO_ACCOUNT: 'demoAccount',
    DENY_WITHDRAWAL: 'denyWithdrawal',
    DEPOSIT_REDIRECT_TO_SUPPORT: 'depositRedirectToSupport',
    DISABLE_DARK_MODE: 'disableDarkMode',
    DISABLE_FIRST_LAST_NAME_LATIN_ONLY: 'disableFirstLastNameLatinOnly',
    DISABLE_GTM: 'disableGTM',
    DISABLE_LUCKY_ORANGE: 'disableLuckyOrange',
    DISABLE_MIXPANEL: 'disableMixPanel',
    DISABLE_RECAPTCHA: 'disableRecaptcha',
    DISABLE_REGISTER_CODE_SECTION: 'disableRegisterCodeSection',
    DISABLE_SOCIAL_AUTH: 'disableSocialAuth',
    DISABLED_WITHDRAWAL_OPEN_POSITIONS: 'disabledWithdrawalOpenPositions',
    DISCLAIMER: 'disclaimer',
    DISCLAIMER_EU: 'disclaimer-eu',
    DISCOUNT_EXCLUDE_ADDONS: 'discountExcludeAddons',
    DYNAMIC_FILE_TYPES: 'dynamicFileTypes',
    EDUCATION_ON_TOP: 'educationOnTop',
    GOOGLE_LOCATION_AUTOCOMPLETE: 'googleLocationAutocomplete',
    HIDE_WD_BTN_DASHBOARD: 'hideWDBtnDashboard',
    INTERCOM: 'intercom',
    KYC: 'kyc',
    KYC_BROKER_17: 'kycBroker17',
    LOGOUT_ON_PASSWORD_CHANGE: 'logoutOnPasswordChange',
    MANUAL_KYC: 'manualKyc',
    MANUAL_MIN_MAX_DEPOSIT: 'manualMinMaxDeposit',
    MANUAL_MIN_WITHDRAWAL: 'manualMinWithdrawal',
    MSG_POPUP: 'msgPopup',
    MTE: 'mte',
    NOTIFICATION_SETTINGS: 'notificationSettings',
    NOTIFICATIONS: 'notifications',
    OLD_KYC_BROKER_7: 'old-kyc-broker-7',
    ONLINE_CONFIG: 'onlineConfig',
    OUTSOURCE_PENDING_DEPOSIT: 'outsourcePendingDeposit',
    PASSWORD_32_CHARACTERS: 'password32Characters',
    PASSWORD_WITH_SPECIAL_CHARACTERS: 'passwordWithSpecialCharacters',
    PROP: 'prop',
    REFER_AND_EARN: 'referAndEarn',
    SEND_IMPROVED_EVENTS_TO_MIXPANEL: 'sendImprovedEventsToMixpanel',
    SHOW_TP_MENU_ACCOUNT_NAME: 'showTpMenuAccountName',
    SHOW_UK_DISCLAIMER_NOTICE: 'showUKDisclaimerNotice',
    SMARTICO_NOTIFICATIONS: 'SmarticoNotifications',
    SOCIAL_BANNER: 'socialBanner',
    SPLASH_SCREEN: 'splashScreen',
    SUMSUB: 'sumsub',
    TRADERS_EDUCATION: 'tradersEducation',
    TRADING_ANALYSIS: 'tradingAnalysis',
    TRADING_PLATFORM_LOGO: 'tradingPlatformLogo',
    UPDATE_ACCOUNT_ADDRESS: 'updateAccountAddress',
    UPLOAD_DOCUMENTS: 'uploadDocuments',
    USE_MAGIC_LINK: 'useMagicLink',
    WHATSAPP_BUTTON: 'whatsappButton',
} as const;

export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];

/**
 * WT feature flag names used throughout the application.
 * These correspond to keys in config.wtFeaturesFlags (from REACT_APP_WT_FEATURES_FLAGS env variable).
 */
export const WTFeatureFlags = {
    TOUR_GUIDE: 'tourGuide',
} as const;

export type WTFeatureFlagKey = (typeof WTFeatureFlags)[keyof typeof WTFeatureFlags];
